import React, { useRef, useState } from 'react';
import {  useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Button from '@components/common/Button';
import LeftNavBar from '../../AppWrapperViewComponent/LeftNavBar';
import BreadcrumbComponent from '@components/common/Breadcrumb';
import { useLocation } from 'react-router-dom';
import NationalEmblem from '@assets/svg_main/national_emblem.svg';
import BackArrowsvg from '@assets/svg_main/BackArrowIconSvg.svg';
import { ChildComponentHandlerUpdateHealthBlockSubDiv } from './edit/index';
import HealthBlockSubDivUpdateUpgrade from './edit';
import HealthBlockManagementView from './view';

interface UserComponentProps {
  page: string;
  flow: string;
}


const TABS = ['Overview',];
const HealthBlockManagementOverView = (props: UserComponentProps) => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const { page, flow } = props;
  const [healthBlockSubDiv, setUser] = useState(JSON.parse(state));
  const [currentTab, setCurrentTab] = useState('Overview');
  const [defaultName, setDefaultName] = useState(healthBlockSubDiv.name);
  const childRef = useRef<ChildComponentHandlerUpdateHealthBlockSubDiv>();


  const updateHandlerUpdate = () => {
    
    if(childRef.current) {
      childRef.current.handleUpdateSave();
    }
  }
  return (
    <div className="app-view-wrapper">
      <header className="view-header">
        <div className="logo-wrapper">
          <NationalEmblem className="logo" />
          <div className="name-wrapper">
            <div className="name-wrapper-title">
              JANANI
            </div>
            <div className="name-wrapper-subtext">
              Journey of Antenatal, Natal and Neonatal Integrated Care
            </div>
            <div className="name-wrapper-subtext" style={{ fontWeight: 'bold' }}>Sehat ke Sath, Every Step of Care</div>
          </div>
        </div>
        <div className="view-route">
          <BreadcrumbComponent
            breadcrumbItemName={[
              { value: page, label: 'Geo NonGeo' },
              { value: page, label: 'Health Block' },
            ]}
          />
        </div>
      </header>
      <main className="view-content">
        <div className="view-profile-buttons">
          <div className="view-profile">
            <Link to={'/healthblock'}>
              <Button
                onClick={() => { }}
                disabled={false}
                id=""
                buttonName={''}
                colorType={'verticalbackbutton'}
                icon={<BackArrowsvg />}
                iconPosition={'left'}
              />
            </Link>
            <div className="name-type">
              <div className="name">{defaultName}</div>
            </div>
          </div>
          <div className="cancel-edit">
            <Button
              onClick={() => {
                navigate('/healthblock');
              }}
              disabled={false}
              id="cancel"
              buttonName={'Cancel'}
              colorType={'save'}
              icon={''}
              iconPosition={''}
            />
            <Button
              onClick={() => {
                flow === 'view' ? navigate(`/healthblock/edit/${healthBlockSubDiv.id}`, {
                  state: JSON.stringify(healthBlockSubDiv),
                }):updateHandlerUpdate()
              }}
              disabled={false}
              id={flow === 'view' ? 'edit-details' : 'save-details'}
              buttonName={flow === 'view' ? 'Edit Details' : 'Save Details'}
              colorType={'primary'}
              icon={''}
              iconPosition={''}
            />
          </div>
        </div>
        <div className="content">
          <LeftNavBar
            navItems={TABS}
            currentTab={currentTab}
            handleNavClick={setCurrentTab}
          />
          <div className="tab-content">
            {currentTab === 'Overview' && flow==='view'?<HealthBlockManagementView  healthBlockSubDiv={healthBlockSubDiv}/> :
            <HealthBlockSubDivUpdateUpgrade ref={childRef} healthBlockSubDiv={healthBlockSubDiv} 

            />}
          </div>
        </div>
      </main>
    </div>
  );
};
export default HealthBlockManagementOverView;
